import styled from 'styled-components';

import { heading5, spacing, colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const NBACreationLoadingContainer = styled.div`
  height: ${spacing.x24};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
`;

export const LoadingTextContainer = styled.div`
  @keyframes loadText {
    0% {
      opacity: 0;
      transform: translateX(75%);
    }
    20%,
    70% {
      opacity: 1;
      transform: translateX(15%);
    }
    100% {
      opacity: 0;
      transform: translateX(-75%);
    }
  }

  @keyframes loadTextLast {
    from {
      opacity: 0;
      transform: translateX(75%);
    }

    to {
      opacity: 1;
      transform: translateX(0%);
    }
  }

  height: ${pxToRem(10)};
  width: ${pxToRem(210)};
  position: relative;
  left: 0%;

  & > h5:not(:nth-child(3)) {
    animation: loadText 6s normal forwards;
  }

  & > h5:nth-child(2) {
    animation-delay: 6s;
  }

  & > h5:nth-child(3) {
    animation: loadTextLast 2s 12s normal forwards;
  }
`;

export const LoadingText = styled.h5`
  ${heading5}
  color: ${colors.textSecondary};
  margin: 0;
  position: absolute;
  opacity: 0;
`;
